// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-panel-callout-content {
  margin: 16px;
  border-radius: 6px;
  overflow: hidden;
  transition-property: transform, opacity;
  transition: transform 200ms cubic-bezier(0.165, 0.84, 0.44, 1), opacity 100ms cubic-bezier(0.215, 0.61, 0.355, 1);
}
@media (forced-colors: active) {
  .bolt-panel-callout-content {
    border: solid 1px;
  }
}
.bolt-panel-callout-content.bolt-callout-shadow {
  box-shadow: 0px 25.6px 57.6px rgba(0, 0, 0, .22), 0px 4.8px 14.4px rgba(0, 0, 0, .18);
  box-shadow: 0px 25.6px 57.6px var(--panel-shadow-color,rgba(0, 0, 0, .22)), 0px 4.8px 14.4px var(--panel-shadow-secondary-color,rgba(0, 0, 0, .18));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-panel-callout-content.bolt-callout-shadow {
  border: 2px solid rgba(0, 120, 212, 1);
  border: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-panel-callout-content.bolt-callout-shadow {
  border: 2px solid rgba(0, 120, 212, 1);
  border: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}
.bolt-panel-callout-content.bolt-panel-fullscreen {
  margin: 0px;
  max-height: none;
  max-width: none;
  height: auto;
  width: auto;
  border-radius: 0px;
}
.bolt-panel-callout-content {
  /* &.in {
      @include in();
  }

  &.out {
      @include out();
  } */
}

.bolt-panel-description {
  margin-right: 36px;
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}

.bolt-panel-footer {
  min-height: 64px;
  overflow: hidden;
  padding-bottom: 16px;
  padding-top: 16px;
}

.bolt-panel-footer-buttons {
  justify-content: flex-end;
  font-size: 0.875rem;
}

.bolt-panel-content {
  position: relative;
  min-height: 64px;
}

.bolt-panel-separator {
  height: 1px;
  background-color: rgba( 244, 244, 244 ,  1 );
  background-color: rgba( var(--palette-neutral-4,244, 244, 244) ,  1 );
}

.bolt-panel-overlay {
  background-color: rgba(255, 255, 255, 1);
  background-color: var(--callout-background-color,rgba(255, 255, 255, 1));
  opacity: 0.7;
}

@media screen and (max-width: 599px) {
  .bolt-panel-header .bolt-header-content-area {
    flex-wrap: nowrap;
  }
}
@media screen and (max-width: 599px) {
  .bolt-panel-header .bolt-header-title {
    white-space: normal;
    word-break: break-word;
  }
}

/*# sourceMappingURL=Panel.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Panel/Panel.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/Panel/Panel.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AAsBA;EACI,YCsSS;EDrST,kBAAA;EACA,gBAAA;EACA,uCAAA;EACA,iHAAA;AErBJ;ACyCI;EHzBJ;IAQQ,iBAAA;EEpBN;AACF;AFsBI;EACI,qFAAA;EEpBN,mJAAmJ;ADwX7I;ACtXR;EACE,sCAAsC;EDwXhC,gEAAA;ACtXR;AACA;EFqBI,sCAAA;EACI,gEAAA;AEnBR;AACA;EFqBQ,WAAA;EACA,gBAAA;EACA,eAAA;EEnBN,YAAY;EFNd,WAAA;EA6BI,kBAAA;AAAA;AAAA;EElBF;;;;;;KF2BF;AEpBA;;AAEA;EACE,kBAAkB;EFsBpB,yBAAA;EACI,qDAAA;AEpBJ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EFsBlB,oBAAA;EACI,iBAAA;AEpBJ;;AAEA;EFwBA,yBAAA;EACI,mBAAA;AEtBJ;;AAEA;EFwBA,kBAAA;EACI,gBAAA;AEtBJ;;AAEA;EFwBA,WAAA;EACI,4CCmGqB;EDlGrB,qEAAA;AEtBJ;;AD2RI;EDjQA,wCAAA;EEtBF,wEFwBU;EEvBV,YAAY;AACd;;AAEA;EACE;IF0BU,iBAAA;EExBV;AACF;AACA;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA,oCAAoC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
